import React, { Component } from 'react'
import ResourceItem from '../../models/resourceItem'
interface iProps {
    extraProps: ResourceItem
}

export default class clazzDocument extends Component<iProps> {
    render() {
        let {extraProps} = this.props
        return (
            <div className="clazzDocument">
                <iframe 
                style={{width:'100%', height:'100%', overflow:'visible'}}
                // onLoad={() => {
                //     const obj = ReactDOM.findDOMNode(this);
                //     this.setState({
                //         "iFrameHeight":  obj.contentWindow.document.body.scrollHeight + 'px'
                //     });
                // }} 
                ref="iframe" 
                src={`https://test.dbxiao.cn/pdfjs/web/viewer.html?file=${encodeURIComponent(extraProps?.playUrl)}`}
                width="100%" 
                // height={this.state.iFrameHeight} 
                scrolling="no" 
                frameBorder="0"
            />
            </div>
        )
    }
}
